import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMH: CultureInfo = {
  name: 'en-MH',
  displayName: 'English (Marshall Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MH',
  parent: CultureInfoEn
};
